import { CompanySummaryDTO } from '../DTOs/CompanySummaryDTO';

export class CompanySummary {
  public static fromDTO(companySummaryDTO: CompanySummaryDTO) {
    return new CompanySummary(
      companySummaryDTO.id.toString(),
      companySummaryDTO.name,
      companySummaryDTO.footerText,
      companySummaryDTO.logoUrl,
      companySummaryDTO.slug,
      companySummaryDTO.languages,
      //Address.fromDTO(companySummaryDTO.address),
      //companySummaryDTO.userIds,
      //companySummaryDTO.seriesIds,
      //companySummaryDTO.productBlueprintIds,
    );
  }

  id: string;
  name: string;
  footerText: string;
  logoUrl: string;
  slug: string;
  languages: string[];
  //address: Address;
  //userIds: string[];
  //seriesIds: string[];
  //productBlueprintIds: string[];

  constructor(
    id: string,
    name: string,
    footerText: string,
    logoURL: string,
    slug: string,
    //address: Address,
    //userIds: string[],
    //seriesIds: string[],
    //productBlueprintIds: string[],
    languages: string[],
  ) {
    this.id = id;
    this.name = name;
    this.footerText = footerText;
    this.logoUrl = logoURL;
    this.slug = slug;
    this.languages = languages;
    //this.address = address;
    //this.userIds = userIds;
    //this.seriesIds = seriesIds;
    //this.productBlueprintIds = productBlueprintIds;
  }
}
